import C from '@/utils/rule/constant'
import BaseCalculator from "./BaseCalculator"

class Zero extends BaseCalculator {

    /**
     * 胸腰差比
     * @type {number}
     */
    ratio_xy = 0
    /**
     * 胸臀差
     * @type {number}
     */
    ratio_xt = 0

    body = {
        [C.B_JXTZ_ST] : {
            '平肩' : 0,
            '正常' : 0,
            '溜肩' : 0,
        },
        [C.B_TX_C] : {
            '干瘦' : 0,
            '正常' : 0,
            '挺胸' : 0,
        },
        [C.B_TB_B] : {
            '微驼' : 0,
            '正常' : 0,
            '驼背' : 0,
        },
        [C.B_TD_B] : {
            '微凸' : 0,
            '正常' : 0,
            '凸肚' : 0,
        },
        [C.B_TTT_HT] : {
            '瘦臀' : 0,
            '正常' : 0,
            '丰臀' : 0,
        },
        [C.B_ZTT_H] : {
            '翘臀' : 0,
            '正常' : 0,
            '坠臀' : 0,
        }
    }

    /**
     * 成衣参数key和计算公式
     * @type {{[p: string]: function(*, *, *): *}}
     * 匹配正则 ((base)|(net)|(plus))\[C\.(C|N)([A-Z_])*\]
     */
    complete_size = {

    }


    /**
     * 覆盖父类方法
     * @param size
     */
    setNetSize(size) {
        super.setNetSize(size)
        // 计算胸腰差比和胸臀差比
        this.ratio_xy = (this.net_size[C.N_ZYW_MWL] / this.net_size[C.N_XW_CL] - 1) * 100
        this.ratio_xt = this.net_size[C.N_XW_CL] - this.net_size[C.N_TW_HL]
    }

    /**
     * 穿衣偏好的加放基础值
     * @param somatotype
     * @param preference
     * @returns {*}
     */
    base(somatotype, preference) {

    }

    /**
     * 加放量值
     * @param somatotype
     * @param preference
     * @returns {*}
     */
    plus(somatotype, preference) {


    }


    /**
     * 计算成衣尺寸
     * @param preference
     * @returns {{}}
     */
    getCompleteSize(preference) {
        this.preference = preference
        // let somatotype = this.custom_somatotype || this.default_somatotype
        let formulas = {
            [C.C_QYC_FCL] : 0,
            [C.C_HYC_BCL] : 0,
            [C.C_XW_CL] : 0,
            [C.C_ZY_MW] : 0,
            [C.C_DW_BL] : 0,
            [C.C_XB_HC] : 0,
            [C.C_JK_SW] : 0,
            [C.C_XK_CW] : 0,
            [C.C_XC_SL] : 0,
            [C.C_DXC_SSL] : 0,
            [C.C_XF_B] : 0,
            [C.C_XK_SO] : 0,
            [C.C_DXXK_SSO] : 0,
            [C.C_LW_CL] : 0,
            [C.C_BK_BW] : 0,
            [C.C_KC_TL] : 0,
            [C.C_YW_WL] : 0,
            [C.C_TW_HL] : 0,
            [C.C_ZLC_FBR] : 0,
            [C.C_HD_T] : 0,
            [C.C_XW_KL] : 0,
            [C.C_XTW_C] : 0,
            [C.C_JK_F] : 0,
            [C.C_XG_CH] : 0,
            [C.C_BPD_B] : 0,
            [C.C_SG_H] : 0,
            [C.C_QC_SL] : 0,
        }

        let result = {}
        for(let key in formulas) {
            let temp = Math.round(formulas[key] * 10) / 10
            result[key] = isNaN(temp) ? 0 : temp
        }


        return result
    }

    getBodySize() {
        let result = {}
        for(let key in this.body_size) {
            if (key in this.body) result[key] = this.body[key][this.body_size[key]] || 0

        }

        return result
    }
}

export default Zero
